import CopilotChannelProvider from './channel/CopilotChannelProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const CopilotProvider = ({
  children,
  createLayer,
  instanceId,
  telemetry
}) => {
  return /*#__PURE__*/_jsx(CopilotChannelProvider, {
    createLayer: createLayer,
    instanceId: instanceId,
    telemetry: telemetry,
    children: children
  });
};
export default CopilotProvider;